import React, { useCallback, useState, useEffect } from 'react';
import {
  ErrorDialog as SharedErrorDialog,
  useTranslationsContext,
} from '@nike/privacy-shared-react';

import { TRANSLATIONS_MAP } from '../../constants';
import { analyticsTrackPageViewedError } from '../../helpers/analyticsHandlers';
import { useUpdateErrorListener } from '../../hooks/useUpdateErrorListener';
import { usePrivacyConsentContext } from '../PrivacyConsentContextProvider';

/**
 * @name ErrorDialog
 * @description Component which renders a dialog to display errors.
 * @returns {JSX.Element|null}
 * @memberof mfe-privacy-consent
 */
export const ErrorDialog = (): JSX.Element | null => {
  const { getMessage } = useTranslationsContext();
  const [isOpen, setIsOpen] = useState(false);
  const { togglePromptIsRequired, contextFrameName, toggleReloadAfterUpdateIsRequired } =
    usePrivacyConsentContext();

  useEffect(() => {
    if (isOpen) analyticsTrackPageViewedError();
  }, [isOpen]);

  useUpdateErrorListener(() => {
    // this `togglePromptIsRequired` function will close a cookie dialog before we show an error dialog.
    togglePromptIsRequired(false);
    toggleReloadAfterUpdateIsRequired(false);
    setIsOpen(true);
  }, contextFrameName);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SharedErrorDialog
      title={getMessage(TRANSLATIONS_MAP.INLINE_SET_ERROR_TITLE)}
      message={getMessage(TRANSLATIONS_MAP.INLINE_SET_ERROR_TEXT_SAVE)}
      actionTitle={getMessage(TRANSLATIONS_MAP.INLINE_SET_ERROR_ACTION_BUTTON_TITLE)}
      isOpen={isOpen}
      closeModal={onClose}
    />
  );
};
